import type { LocationResponse } from "@models/location";
import { LocationResubmitForm } from "@components/Locations/LocationResubmitForm";
import { rejectionLine } from "@components/Locations/_helpers/rejectionLine";

interface LocationResubmitCardProps {
    location: LocationResponse;
    // True once this location was resubmitted in this visit. The refetch flips
    // its status to Pending, but the confirmation has to outlive that — the
    // parent keeps the card mounted and this flag swaps the form for it.
    isResubmitted: boolean;
    onResubmitted: (locationId: string) => void;
}

// One rejected location on the pending wall (#198 / E5-S11): the reason it was
// rejected plus an in-place certificate re-upload. Replaces the old link back
// to /apply, which 409s on the email dedup under the per-location model.
export const LocationResubmitCard = ({
    location,
    isResubmitted,
    onResubmitted,
}: LocationResubmitCardProps) => (
    <li className="rounded-2xl bg-base-200 p-6">
        <p className="font-bold">{location.name}</p>

        {/* The API preserves the rejection reason on resubmit (it is the
            only record of the prior review), so once this card shows the
            confirmation the line must be suppressed — "Rejected: …" over
            "Resubmitted — under review." reads as a contradiction. */}
        {!isResubmitted && (
            <p className="mt-1 text-sm text-neutral/70">
                {rejectionLine(location)}
            </p>
        )}

        {isResubmitted ? (
            <p className="mt-4 text-sm">Resubmitted — under review.</p>
        ) : (
            <LocationResubmitForm
                location={location}
                onResubmitted={onResubmitted}
            />
        )}
    </li>
);
